export enum ReactionType {
    like = "like",
    dislike = "dislike"
}